import {GalleryCategories} from "../hooks/useDynamicImageLoading";

import bg1 from "../assets/images/resources/backgrounds/MOTIVO_01.jpg";
import bg2 from "../assets/images/resources/backgrounds/MOTIVO_03.jpg";
import bg3 from "../assets/images/resources/backgrounds/MOTIVO_05.jpg";
import bg4 from "../assets/images/resources/backgrounds/MOTIVO_06.jpg";
import bg5 from "../assets/images/resources/backgrounds/MOTIVO_07.jpg";
import bg6 from "../assets/images/resources/backgrounds/MOTIVO_10.jpg";
import bg7 from "../assets/images/resources/backgrounds/MOTIVO_13.jpg";
import bg8 from "../assets/images/resources/backgrounds/MOTIVO_14.jpg";
import bg9 from "../assets/images/resources/backgrounds/MOTIVO_15.jpg";
import bg10 from "../assets/images/resources/backgrounds/MOTIVO_16.jpg";

import texture1 from "../assets/images/resources/textures/TEXTURA_01.png";
import texture2 from "../assets/images/resources/textures/TEXTURA_02.png";
import texture3 from "../assets/images/resources/textures/TEXTURA_03.png";
import texture4 from "../assets/images/resources/textures/TEXTURA_04.png";
import texture5 from "../assets/images/resources/textures/TEXTURA_05.png";
import texture6 from "../assets/images/resources/textures/TEXTURA_06.png";
import texture7 from "../assets/images/resources/textures/TEXTURA_07.png";
import texture8 from "../assets/images/resources/textures/TEXTURA_08.png";

import ph1 from "../assets/images/resources/disc/photos/FOTOS_DISCO_01.jpg";
import ph2 from "../assets/images/resources/disc/photos/FOTOS_DISCO_02.jpg";
import ph3 from "../assets/images/resources/disc/photos/FOTOS_DISCO_03.jpg";
import ph4 from "../assets/images/resources/disc/photos/FOTOS_DISCO_04.jpg";
import ph5 from "../assets/images/resources/disc/photos/FOTOS_DISCO_06.jpg";
import ph6 from "../assets/images/resources/disc/photos/FOTOS_DISCO_07.jpg";
import ph7 from "../assets/images/resources/disc/photos/FOTOS_DISCO_08.jpg";
import ph8 from "../assets/images/resources/disc/photos/FOTOS_DISCO_10.jpg";
import ph9 from "../assets/images/resources/disc/photos/FOTOS_DISCO_11.jpg";
import ph10 from "../assets/images/resources/disc/photos/FOTOS_DISCO_12.jpg";

import detail1 from "../assets/images/resources/disc/details/CANCIONES_DISCO_01.png";
import detail2 from "../assets/images/resources/disc/details/CANCIONES_DISCO_02.png";
import detail3 from "../assets/images/resources/disc/details/CANCIONES_DISCO_03.png";
import detail4 from "../assets/images/resources/disc/details/CANCIONES_DISCO_04.png";
import detail5 from "../assets/images/resources/disc/details/CANCIONES_DISCO_05.png";
import detail6 from "../assets/images/resources/disc/details/SELLOS_DISCOS_01.png";
import detail7 from "../assets/images/resources/disc/details/SELLOS_DISCOS_02.png";
import detail8 from "../assets/images/resources/disc/details/SELLOS_DISCOS_04.png";
import detail9 from "../assets/images/resources/disc/details/SELLOS_DISCOS_05.png";
import detail10 from "../assets/images/resources/disc/details/SELLOS_DISCOS_08.png";

import title1 from "../assets/images/resources/disc/titles/AUTORES_DISCO_01.png";
import title2 from "../assets/images/resources/disc/titles/AUTORES_DISCO_03.png";
import title3 from "../assets/images/resources/disc/titles/AUTORES_DISCO_04.png";
import title4 from "../assets/images/resources/disc/titles/AUTORES_DISCO_05.png";
import title5 from "../assets/images/resources/disc/titles/AUTORES_DISCO_08.png";
import title6 from "../assets/images/resources/disc/titles/TITULO_DISCO_01.png";
import title7 from "../assets/images/resources/disc/titles/TITULO_DISCO_07.png";
import title8 from "../assets/images/resources/disc/titles/TITULO_DISCO_11.png";
import title9 from "../assets/images/resources/disc/titles/TITULO_DISCO_12.png";
import title10 from "../assets/images/resources/disc/titles/TITULO_DISCO_14.png";

import iconFondos from "../assets/images/icons/icon_fondos.svg";
import iconFondosSelected from "../assets/images/icons/icon_fondos_selected.svg";
import iconTexturas from "../assets/images/icons/icon_texturas.svg";
import iconTexturasSelected from "../assets/images/icons/icon_texturas_selected.svg";
import iconFotos from "../assets/images/icons/icon_fotografias.svg";
import iconFotosSelected from "../assets/images/icons/icon_fotografias_selected.svg";
import iconDetalles from "../assets/images/icons/icon_detalles.svg";
import iconDetallesSelected from "../assets/images/icons/icon_detalles_selected.svg";
import iconTitulos from "../assets/images/icons/icon_titulos.svg";
import iconTitulosSelected from "../assets/images/icons/icon_titulos_selected.svg";

export const CARATULA_DISCO_SETTINGS: SelectedCategorySettings<GalleryCategories> = {
    title: '01 • Carátula de disco',
    gallery: {
        fondos: {
            style: {
                objectFit: 'cover',
                objectPosition: 'top',
            },
            images: [bg1, bg2, bg3, bg4, bg5, bg6, bg7, bg8, bg9, bg10],
        },
        texturas: {
            style: {
                objectFit: 'contain',
                backgroundColor: '#8d8d8d',
            },
            images: [texture1, texture2, texture3, texture4, texture5, texture6, texture7, texture8],
        },
        fotos: {
            style: {
                objectFit: 'cover',
                objectPosition: 'top',
            },
            images: [ph1, ph2, ph3, ph4, ph5, ph6, ph7, ph8, ph9, ph10],
        },
        detalles: {
            style: {
                objectFit: 'contain',
                backgroundColor: '#c9c9c9',
            },
            images: [
                detail1,
                detail2,
                detail3,
                detail4,
                detail5,
                detail6,
                detail7,
                detail8,
                detail9,
                detail10,
            ],
        },
        titulos: {
            style: {
                objectFit: 'contain',
                backgroundColor: '#c9c9c9',
            },
            images: [title1, title2, title3, title4, title5, title6, title7, title8, title9, title10],
        },
    },
    toolsSelection: [
        {
            key: 'fondos',
            name: 'Fondos',
            icon: iconFondos,
            selectedIcon: iconFondosSelected,
        },
        {
            key: 'texturas',
            name: 'Texturas',
            icon: iconTexturas,
            selectedIcon: iconTexturasSelected,
        },
        {
            key: 'fotos',
            name: 'Fotos',
            icon: iconFotos,
            selectedIcon: iconFotosSelected,
        },
        {
            key: 'detalles',
            name: 'Detalles',
            icon: iconDetalles,
            selectedIcon: iconDetallesSelected,
        },
        {
            key: 'titulos',
            name: 'Títulos',
            icon: iconTitulos,
            selectedIcon: iconTitulosSelected,
        },
    ],
};
